import { useMemo } from "react";
import { Center, Spinner } from "@chakra-ui/react";

import { useGetDebtStateQuery } from "../../../../api/debt";
import { useGetScheduleQuery } from "../../../../api/schedule";
import { IScheduleItem } from "../../../../api/schedule/types.ts";
import { PageContentLayout } from "../../../shared/PageContentLayout";
import { PaymentsSchedulePageError } from "./PaymentsSchedulePageError";
import { PaymentsScheduleOverpayment } from "../PaymentScheduleOverpayment";
import { PaymentsScheduleList, PaymentsSchedulePayment, PaymentsScheduleTodayDebt } from "../index.ts";

export function PaymentsSchedulePageContent() {
  const {
    data: initSchedule,
    isPending: isSchedulePending,
    isError: isScheduleError,
  } = useGetScheduleQuery();

  const {
    data: debt,
    isPending: isDebtPending,
    isError: isDebtError,
  } = useGetDebtStateQuery();

  const { nearestPayment, formattedSchedule } = useMemo(() => {
    let nearestPayment: IScheduleItem | undefined;

    const sortedSchedule = Array.isArray(initSchedule?.periods)
      ? [...initSchedule.periods].sort((a, b) => (a.idx ?? 0) - (b.idx ?? 0))
      : [];

    const formattedSchedule = sortedSchedule.map((item) => {
      if (item.status === "PLANNED" && !nearestPayment) {
        nearestPayment = item;
        return { ...item, isNearestPayment: true };
      }

      return { ...item, isNearestPayment: false };
    });

    return {
      nearestPayment,
      formattedSchedule,
    };
  }, [initSchedule]);

  if (isSchedulePending || isDebtPending) {
    return (
      <Center flex="1" mb="100px">
        <Spinner />
      </Center>
    );
  }

  if (isScheduleError || isDebtError) {
    return (
      <PaymentsSchedulePageError isScheduleError={isScheduleError} isDebtError={isDebtError} />
    );
  }

  return (
    <PageContentLayout spacing={4}>
      <PaymentsSchedulePayment nearestPayment={nearestPayment} debt={debt} />
      <PaymentsScheduleOverpayment />
      <PaymentsScheduleTodayDebt />
      <PaymentsScheduleList schedule={formattedSchedule} />
    </PageContentLayout>
  );
}
